import { Container } from '@material-ui/core';
import { useFooterStyles } from './FooterStyles';
import { Social } from './components/Social';

export const Footer = () => {
  const classes = useFooterStyles();
  return (
    <footer className={classes.root}>
      <Container maxWidth={false} className={classes.container}>
        <Social
          twitter={'https://x.com/0xBitcoin_Pump'}
          telegram={'https://www.telegram.com'}
        />
      </Container>
    </footer>
  );
};
